var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M3.429 5.714 8 10.286l4.571-4.572"}})])
}
var staticRenderFns = []

export default { render: render }